import React from "react";

function TitleIntakeMobile() {
  return (
    <div className="title-line-mobile-bis">
      <div className="title-block1-mobile">Name </div>
      <div className="title-block2-mobile">Intake date</div>
      <div className="title-block3-mobile">Actions</div>
    </div>
  );
}

export default TitleIntakeMobile;
